/* eslint-disable */
import React from "react";
import { CalendarYear } from '../../../controls/CalendarYear';
import { ICalendarItem, useDictionary, useParameter } from "../../../shared";
import { dictionaryService } from "../../../dataFlow";
import { equal } from "../../../../../shared";

export const CalendarControl: React.FC = () => {
    const [controlValue, setControlValue] = React.useState<string | undefined>();
    const [calendarValue, setCalendarValue] = useParameter<number>("@calendar");

    React.useEffect(() => {
        const nextControlValue = calendarValue === undefined ? undefined : String(calendarValue);
        if (!equal(nextControlValue, controlValue)) {
            setControlValue(nextControlValue);
        }
    }, [calendarValue]);

    const handlerChange = React.useCallback((value: unknown) => {
        const yearId = value as number;
        setControlValue(String(yearId));
        setCalendarValue(yearId);        
    }, []);

    const [FIRST_YEAR] = [119960101];
    const [lastYear] = useParameter("@last_year");
    return <CalendarYear label="Calendar" firstYear={FIRST_YEAR} lastYear={lastYear} value={controlValue} onChange={handlerChange} dictionary="slides-calendar" />;
};
